// Locale-aware date format maps.
// Keys match BCP 47 language tags stored in workspace.config.locale.
// All formats use moment.js / dayjs token syntax.
// READABLE_DATE_TIME_FORMAT_DATEFNS uses date-fns tokens (react-datepicker).

export const DATE_FORMATS = {
  "en-AU": {
    short: "DD/MM/YYYY",
    shortDateTime: "DD/MM/YYYY HH:mm:ss",
    readable: "DD MMM YYYY",
    readableDateTime: "hh:mma DD MMM YYYY",
    readableDateTimeFilename: "YYYYMMDD-HHmm",
    columnHeader: "DD\u00A0MMM\u00A0YYYY",
    dateFns: "hh:mma dd MMM yyyy",
    /** Short date for chart axes / tooltips \u2014 no year. */
    chartDate: "D MMM",
    /** Day-of-week header for Detail view grouping. */
    dayHeader: "ddd D MMM YYYY",
  },
  "en-GB": {
    short: "DD/MM/YYYY",
    shortDateTime: "DD/MM/YYYY HH:mm:ss",
    readable: "DD MMM YYYY",
    readableDateTime: "hh:mma DD MMM YYYY",
    readableDateTimeFilename: "YYYYMMDD-HHmm",
    columnHeader: "DD\u00A0MMM\u00A0YYYY",
    dateFns: "hh:mma dd MMM yyyy",
    chartDate: "D MMM",
    dayHeader: "ddd D MMM YYYY",
  },
  "en-US": {
    short: "MM/DD/YYYY",
    shortDateTime: "MM/DD/YYYY HH:mm:ss",
    readable: "MMM DD, YYYY",
    readableDateTime: "hh:mma MMM DD, YYYY",
    readableDateTimeFilename: "YYYYMMDD-HHmm",
    columnHeader: "MMM\u00A0DD,\u00A0YYYY",
    dateFns: "hh:mma MMM dd, yyyy",
    chartDate: "MMM D",
    dayHeader: "ddd MMM D, YYYY",
  },
};

export const DEFAULT_LOCALE = "en-AU";

export const getDateFormats = (locale) =>
  DATE_FORMATS[locale] || DATE_FORMATS[DEFAULT_LOCALE];
